import * as React from 'react';
import {useToken, Pressable} from 'native-base';

interface IconProps {
  width?: string;
  height?: string;
  color: string;
  mr: string;
  onPress: () => void;
}

export default ({width, height, color, mr, onPress}: IconProps) => {
  const [fillColor] = useToken('colors', [color]);

  const handleOnPress = () => {
    if (onPress) {
      onPress();
    }
  };

  return (
    <Pressable marginRight={mr} onPress={handleOnPress}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 512 512"
        fill={fillColor ? fillColor : 'black'}>
        <circle cx="256" cy="256" r="64" />
        <path d="M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96c-42.52 0-84.33 12.15-124.27 36.11-40.73 24.43-77.63 60.12-109.68 106.07a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416c46.71 0 93.81-14.43 136.2-41.72 38.46-24.77 72.72-59.66 99.08-100.92a32.2 32.2 0 00-.1-34.76zM256 352a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
      </svg>
    </Pressable>
  );
};
